import FloorPlan from './FloorPlan';

export default FloorPlan;
